export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-c9adb5a2a928459289760b1428724f89.png";